import BaseAPI from '@/apis/base/baseApi';
export default class SYSApi extends BaseAPI {
  apiName = 'SYS';
}
